import { AxiosInstance } from "axios";
import useAuthenticatedFetch from "./useAuthenticatedFetch";

export interface AlarmHandling {
  id: number;
  name: string;
}

const fetchAlarmHandlings = (objectId: string) => {
  const { data, isLoading, isError } = useAuthenticatedFetch<AlarmHandling[]>(
    `/api/v2/users/${objectId}/alarmhandlings`,
  );

  return { data, isLoading, isError };
};

const getAlarmHandlings = (
  authenticatedRequest: AxiosInstance,
  objectId: string,
) =>
  authenticatedRequest.get<AlarmHandling[]>(
    `/api/v2/users/${objectId}/alarmhandlings`,
  );

const saveTemporaryHandling = (
  authenticatedRequest: AxiosInstance,
  objectId: string,
  data: {
    id?: number;
    end?: Date;
  },
) =>
  authenticatedRequest.post(
    `/api/v2/users/${objectId}/temporaryalarmhandling`,
    JSON.stringify(data),
    { headers: { "Content-Type": "application/json" } },
  );

const batchCancelTemporaryHandling = (
  authenticatedRequest: AxiosInstance,
  userIds: string[],
) =>
  authenticatedRequest.post(
    `/api/v2/users/temporaryalarmhandling/batch`,
    JSON.stringify({ userIds, id: null }),
    { headers: { "Content-Type": "application/json" } },
  );

const batchSaveTemporaryHandling = (
  authenticatedRequest: AxiosInstance,
  userIds: string[],
  data: {
    id?: number;
    end?: Date;
  },
) =>
  authenticatedRequest.post(
    `/api/v2/users/temporaryalarmhandling/batch`,
    JSON.stringify({ userIds, ...data }),
    { headers: { "Content-Type": "application/json" } },
  );

const batchFetchTemporaryHandling = (
  authenticatedRequest: AxiosInstance,
  userIds: string[],
) =>
  authenticatedRequest.post<AlarmHandling[]>(
    `/api/v2/users/alarmhandlings/batch`,
    JSON.stringify({ userIds }),
    { headers: { "Content-Type": "application/json" } },
  );

const batchSaveAlarmHandling = (
  authenticatedRequest: AxiosInstance,
  userIds: string[],
  alarmHandlingId: number,
) =>
  authenticatedRequest.post(
    `/api/v2/users/alarmhandling/batch`,
    JSON.stringify({ userIds, alarmHandlingId }),
    { headers: { "Content-Type": "application/json" } },
  );

export {
  fetchAlarmHandlings,
  getAlarmHandlings,
  saveTemporaryHandling,
  batchCancelTemporaryHandling,
  batchSaveTemporaryHandling,
  batchFetchTemporaryHandling,
  batchSaveAlarmHandling,
};
